import { useMemo } from 'react';
import { Widget } from '@/modules/widgets/types';
import { Page, PageTab } from "@/modules/pages/types";
import { canViewWidget } from '@/modules/widgets/utils/permissions';

interface Tab {
    id?: number;
    tags?: string | string[] | null;
    disabled?: boolean;
}

interface UseFilteredWidgetsParams {
    widgets: Widget[];
    tabs: Tab[];
    currentTab: Tab | null;
    user: any;
    page: Page | null;
}

export function filterWidgetsByTab(widgets: Widget[], tabs: Tab[], currentTab: Tab | null, user: any): Widget[] {
    const visibleWidgets = widgets.filter((widget) => canViewWidget(widget, user));
    const hasTabs = tabs.length > 0;

    if (!hasTabs) return visibleWidgets;

    if (!currentTab?.tags?.length) {
        return visibleWidgets.filter((widget) => {
            const widgetTab = tabs.find((tab) => (widget.tag === currentTab?.tags || tab.tags?.includes(widget.tag ?? "")) && tab.disabled === false);
            return Boolean(widgetTab);
        });
    }

    return visibleWidgets
        .filter((widget) => {
            return widget.tag === currentTab.tags || currentTab.tags?.includes(widget.tag ?? "");
        })
        .filter((widget) => {
            const widgetTab = tabs.find((tab) => tab.tags?.includes(widget.tag ?? "") && tab.disabled === false);
            return Boolean(widgetTab);
        });
}

export function useFilteredWidgets({ widgets, tabs, currentTab, user, page }: UseFilteredWidgetsParams): Widget[] {
    return useMemo(() => {
        return filterWidgetsByTab(widgets, tabs, currentTab, user);
    }, [widgets, currentTab?.tags, tabs, user, page]);
}
